// Ensure this script is loaded AFTER your modal HTML

// Cart utilities removed - now using product-form custom element

// Utility function to convert rich text JSON to HTML
function richTextToHTML(node) {
  if (!node) return "";

  // Text node
  if (node.type === "text") {
    let text = node.value || node.text || "";

    if (node.bold) text = `<strong>${text}</strong>`;
    if (node.italic) text = `<em>${text}</em>`;
    if (node.underline) text = `<u>${text}</u>`;
    if (node.strikethrough || node.strike) text = `<s>${text}</s>`;
    if (node.code) text = `<code>${text}</code>`;

    return text;
  }

  // Recursively handle children
  const childrenHTML = (node.children || []).map(richTextToHTML).join("");

  switch (node.type) {
    case "root":
    case "doc":
      return childrenHTML;

    case "paragraph":
      return `<p>${childrenHTML}</p>`;

    case "heading":
      const level = node.level || 1;
      return `<h${level}>${childrenHTML}</h${level}>`;

    case "list":
      return node.listType === "ordered"
        ? `<ol>${childrenHTML}</ol>`
        : `<ul>${childrenHTML}</ul>`;

    case "list-item":
      return `<li>${childrenHTML}</li>`;

    case "blockquote":
      return `<blockquote>${childrenHTML}</blockquote>`;

    case "link":
      const href = node.href || node.url;
      const target = node.target ? `target="${node.target}"` : "";
      return `<a href="${href}" ${target}>${childrenHTML}</a>`;

    case "image":
      return `<img src="${node.src}" alt="${node.alt || ""}" />`;

    case "code-block":
      return `<pre><code>${childrenHTML}</code></pre>`;

    case "horizontal-rule":
      return `<hr />`;

    case "hardBreak":
    case "line-break":
      return `<br/>`;

    default:
      return childrenHTML; // fallback
  }
}

// Utility function to parse and render metafield content
function parseMetafieldContent(element) {
  if (!element) return;

  const content = element.textContent.trim();

  // Try to parse as JSON (for rich text metafields)
  try {
    const parsed = JSON.parse(content);

    // Check if it's a rich text structure
    if (
      parsed &&
      (parsed.type === "root" || parsed.type === "doc" || parsed.children)
    ) {
      const html = richTextToHTML(parsed);
      element.innerHTML = html;
      return;
    }
  } catch (e) {
    // Not JSON, leave as-is
  }
}

// Utility function to optimize Shopify image URLs with size parameter
function getOptimizedImageUrl(url, size) {
  if (!url) return url;

  // Remove any existing size parameters
  const baseUrl = url.replace(
    /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)\.(jpg|jpeg|png|gif|webp)/i,
    ".$2"
  );

  // For Shopify CDN images, add size parameter
  if (baseUrl.includes("shopify.com") || baseUrl.includes("cdn.shopify")) {
    const extension = baseUrl.match(/\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
    if (extension) {
      const ext = extension[1];
      const params = extension[2] || "";
      return baseUrl.replace(
        /\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i,
        `_${size}.${ext}${params}`
      );
    }
  }

  return url;
}

// Utility function to format money using Shopify's settings
function formatMoneyForQuickView(cents, format) {
  try {
    if (typeof cents === "string") cents = cents.replace(".", "");
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString =
      format || window.Shopify?.money_format || "₹{{amount}}";

    // Check if format string contains placeholder
    if (!placeholderRegex.test(formatString)) {
      // Fallback if format string is malformed
      return `₹${(cents / 100).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  } catch (error) {
    console.warn("Error formatting money in quick view:", error);
    // Ultimate fallback
    return `₹${(cents / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
}

// Touch/Swipe functionality for image gallery
function setupTouchSwipe(imageElement, onSwipeLeft, onSwipeRight) {
  if (!imageElement) return;

  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let isSwiping = false;
  let isHorizontalSwipe = false;
  let swipeThreshold = 50; // Minimum distance for a swipe
  let swipeTimeout = null;

  const imageContainer = imageElement.closest(".qv-main-image-display");
  if (!imageContainer) return;

  // Create swipe indicators
  const leftIndicator = document.createElement("div");
  leftIndicator.className = "qv-swipe-indicator left";
  leftIndicator.innerHTML = "‹";

  const rightIndicator = document.createElement("div");
  rightIndicator.className = "qv-swipe-indicator right";
  rightIndicator.innerHTML = "›";

  imageContainer.appendChild(leftIndicator);
  imageContainer.appendChild(rightIndicator);

  function handleTouchStart(e) {
    if (e.touches.length !== 1) return;

    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    currentX = startX;
    isSwiping = true;
    isHorizontalSwipe = false;

    imageElement.classList.add("swiping");
    imageContainer.classList.add("swipe-feedback");
  }

  function handleTouchMove(e) {
    if (!isSwiping || e.touches.length !== 1) return;

    const touch = e.touches[0];
    currentX = touch.clientX;
    const currentY = touch.clientY;

    const diffX = Math.abs(currentX - startX);
    const diffY = Math.abs(currentY - startY);

    // Determine if this is a horizontal swipe
    if (!isHorizontalSwipe && (diffX > 10 || diffY > 10)) {
      isHorizontalSwipe = diffX > diffY;
    }

    // Only prevent default and show indicators for horizontal swipes
    if (isHorizontalSwipe) {
      e.preventDefault();

      const swipeDistance = currentX - startX;
      const absDistance = Math.abs(swipeDistance);

      // Show appropriate indicator based on swipe direction
      if (absDistance > 20) {
        if (swipeDistance > 0) {
          leftIndicator.classList.add("visible");
          rightIndicator.classList.remove("visible");
        } else {
          rightIndicator.classList.add("visible");
          leftIndicator.classList.remove("visible");
        }
      } else {
        leftIndicator.classList.remove("visible");
        rightIndicator.classList.remove("visible");
      }

      // Add subtle visual feedback to the image
      const transform = Math.max(-30, Math.min(30, swipeDistance * 0.1));
      imageElement.style.transform = `translateX(${transform}px)`;
    }
  }

  function handleTouchEnd(e) {
    if (!isSwiping) return;

    // Clear classes and styles
    imageElement.classList.remove("swiping");
    imageContainer.classList.remove("swipe-feedback");
    leftIndicator.classList.remove("visible");
    rightIndicator.classList.remove("visible");

    // Reset image position
    imageElement.style.transform = "";

    // Only process horizontal swipes
    if (isHorizontalSwipe) {
      const swipeDistance = currentX - startX;
      const absDistance = Math.abs(swipeDistance);

      if (absDistance >= swipeThreshold) {
        if (swipeDistance > 0) {
          // Swiped right - go to previous image
          onSwipeLeft && onSwipeLeft();
        } else {
          // Swiped left - go to next image
          onSwipeRight && onSwipeRight();
        }
      }
    }

    // Reset state
    isSwiping = false;
    isHorizontalSwipe = false;
    startX = 0;
    startY = 0;
    currentX = 0;
  }

  // Add event listeners
  imageContainer.addEventListener("touchstart", handleTouchStart, {
    passive: false,
  });
  imageContainer.addEventListener("touchmove", handleTouchMove, {
    passive: false,
  });
  imageContainer.addEventListener("touchend", handleTouchEnd, {
    passive: true,
  });

  // Clean up function (optional, for removing listeners)
  return function cleanup() {
    imageContainer.removeEventListener("touchstart", handleTouchStart);
    imageContainer.removeEventListener("touchmove", handleTouchMove);
    imageContainer.removeEventListener("touchend", handleTouchEnd);
    leftIndicator.remove();
    rightIndicator.remove();
  };
}

function openQuickViewOriginal(productHandle) {
  // Store the current product handle globally for cart events
  window._currentQuickViewProduct = productHandle;

  const modal = document.getElementById("quickViewModal");
  if (!modal) return;

  const loaderOverlay = modal.querySelector("#qvLoaderOverlay");
  const mainImageElement = modal.querySelector(".qv-image-main");
  const titleElement = modal.querySelector(".qv-product-title-display");
  const priceElement = modal.querySelector(".qv-product-price-display");
  const descriptionElement = null;
  const productFormContainer = modal.querySelector("#qvProductFormContainer");
  const thumbnailGrid = modal.querySelector("#qvThumbnailGrid");
  const prevBtn = modal.querySelector(".qv-nav-prev");
  const nextBtn = modal.querySelector(".qv-nav-next");

  // Show modal and loader
  modal.style.display = "flex";

  // Prevent body scroll when modal opens and store current scroll position
  const scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = "100%";
  document.body.classList.add("qv-modal-open");
  document.body.classList.add("qv-modal-transition");

  // Store scroll position for restoration
  modal.setAttribute("data-scroll-y", scrollY);

  window.setTimeout(() => {
    document.body.classList.remove("qv-modal-transition");
  }, 300);

  // Show loader immediately
  if (loaderOverlay) loaderOverlay.classList.remove("hidden");

  // Reset basic content
  if (mainImageElement) {
    mainImageElement.src = "";
    mainImageElement.alt = "";
  }
  if (titleElement) titleElement.textContent = "Loading...";
  if (priceElement) priceElement.textContent = "";
  // description removed from quick view
  if (productFormContainer) productFormContainer.innerHTML = "";
  if (thumbnailGrid) thumbnailGrid.innerHTML = "";
  if (prevBtn) prevBtn.disabled = true;
  if (nextBtn) nextBtn.disabled = true;

  // Clear horizontal scroll
  const horizontalScroll = modal.querySelector("#qvHorizontalThumbnailScroll");
  if (horizontalScroll) horizontalScroll.innerHTML = "";

  // Disable horizontal slider buttons
  const horizontalPrevBtn = modal.querySelector(".qv-slider-button--prev");
  const horizontalNextBtn = modal.querySelector(".qv-slider-button--next");
  if (horizontalPrevBtn) horizontalPrevBtn.disabled = true;
  if (horizontalNextBtn) horizontalNextBtn.disabled = true;

  // 1) Fetch product JSON (for title/price/desc/images)
  const productJsonPromise = fetch(`/products/${productHandle}.js`).then(
    (r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    }
  );

  // 2) Fetch rendered product form via Sections API
  const sectionPromise = fetch(
    `/products/${productHandle}?section_id=quick-view-product`
  ).then((r) => {
    if (!r.ok) throw new Error(`Section HTTP ${r.status}`);
    return r.text();
  });

  Promise.allSettled([productJsonPromise, sectionPromise])
    .then(([productRes, sectionRes]) => {
      // Hide loader immediately when content is ready
      if (loaderOverlay) loaderOverlay.classList.add("hidden");

      // Populate basic fields and build thumbnails
      if (productRes.status === "fulfilled") {
        const product = productRes.value;
        if (titleElement) titleElement.textContent = product.title || "";

        if (priceElement) {
          const cents = typeof product.price === "number" ? product.price : 0;

          // Use Shopify money formatting or fallback
          if (window.Shopify?.money_format) {
            priceElement.textContent = formatMoneyForQuickView(
              cents,
              window.Shopify.money_format
            );
          } else if (window.Shopify?.money_with_currency_format) {
            priceElement.textContent = formatMoneyForQuickView(
              cents,
              window.Shopify.money_with_currency_format
            );
          } else {
            // Final fallback for Indian Rupees
            priceElement.textContent = `₹${(cents / 100).toLocaleString(
              "en-IN",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            )}`;
          }
        }

        // description removed from quick view

        // Build a normalized images array (string URLs)
        const imageUrls = Array.isArray(product.images)
          ? product.images
              .map((img) => (img && img.src ? img.src : img))
              .filter(Boolean)
          : [];

        // Determine initial main image
        const featured =
          product.featured_image &&
          (product.featured_image.src || product.featured_image);
        let currentIndex = 0;
        if (featured) {
          const idx = imageUrls.indexOf(featured);
          currentIndex = idx >= 0 ? idx : 0;
        }

        const setMainImage = (index, direction = "none") => {
          if (!mainImageElement || !imageUrls.length) return;
          const url = imageUrls[index] || imageUrls[0];

          // Add smooth transition animation
          const imageContainer = mainImageElement.closest(
            ".qv-main-image-display"
          );

          // Determine animation direction
          let animationClass = "";
          if (direction === "next") {
            animationClass = "qv-slide-in-right";
          } else if (direction === "prev") {
            animationClass = "qv-slide-in-left";
          } else {
            animationClass = "qv-fade-in";
          }

          // Add fade out effect
          mainImageElement.style.opacity = "0";
          mainImageElement.style.transform =
            direction === "next"
              ? "translateX(-30px)"
              : direction === "prev"
              ? "translateX(30px)"
              : "scale(0.95)";

          // Wait for fade out, then change image
          setTimeout(() => {
            // Use large size for main image (1024x1024) for faster loading
            mainImageElement.src = getOptimizedImageUrl(url, "large");
            mainImageElement.alt = product.title || "Product image";

            // Preload the image to ensure smooth transition
            const img = new Image();
            img.src = getOptimizedImageUrl(url, "large");
            img.onload = () => {
              // Fade in with slide animation
              requestAnimationFrame(() => {
                mainImageElement.style.opacity = "1";
                mainImageElement.style.transform = "translateX(0) scale(1)";
              });
            };
          }, 150);
        };

        const updateActiveThumb = (index) => {
          if (!thumbnailGrid) return;
          const thumbnails =
            thumbnailGrid.querySelectorAll(".qv-thumbnail-item");
          thumbnails.forEach((el, i) => {
            el.classList.toggle("active", i === index);
          });

          // Update horizontal scroll items
          const horizontalScroll = modal.querySelector(
            "#qvHorizontalThumbnailScroll"
          );
          if (horizontalScroll) {
            const horizontalItems = horizontalScroll.querySelectorAll(
              ".qv-horizontal-thumbnail-item"
            );
            horizontalItems.forEach((el, i) => {
              el.classList.toggle("active", i === index);
            });

            // Scroll active item into view in horizontal scroll
            const activeItem = horizontalItems[index];
            if (activeItem) {
              activeItem.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
              });
            }
          }

          // Scroll active thumbnail into view in the carousel
          const activeThumbnail = thumbnails[index];
          if (activeThumbnail) {
            activeThumbnail.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "center",
            });
          }
        };

        const goToIndex = (index, direction = "none") => {
          if (!imageUrls.length) return;
          const prevIndex = currentIndex;
          currentIndex = (index + imageUrls.length) % imageUrls.length;

          // Determine direction if not specified
          let slideDirection = direction;
          if (direction === "none" && prevIndex !== currentIndex) {
            slideDirection = currentIndex > prevIndex ? "next" : "prev";
          }

          setMainImage(currentIndex, slideDirection);
          updateActiveThumb(currentIndex);
        };

        const prev = () => goToIndex(currentIndex - 1, "prev");
        const next = () => goToIndex(currentIndex + 1, "next");

        // Render thumbnails
        if (thumbnailGrid) {
          if (imageUrls.length) {
            thumbnailGrid.innerHTML = "";
            imageUrls.forEach((imgUrl, index) => {
              const thumb = document.createElement("img");
              // Use small size for thumbnails (160x160) for faster loading
              thumb.src = getOptimizedImageUrl(imgUrl, "small");
              thumb.alt = `${product.title || "Product"} - image ${index + 1}`;
              thumb.className =
                "qv-thumbnail-item" + (index === currentIndex ? " active" : "");
              thumb.tabIndex = 0;
              thumb.addEventListener("click", () => goToIndex(index));
              thumb.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  goToIndex(index);
                }
              });
              thumbnailGrid.appendChild(thumb);
            });
          }
        }

        // Render horizontal scroll thumbnails
        const horizontalScroll = modal.querySelector(
          "#qvHorizontalThumbnailScroll"
        );
        if (horizontalScroll) {
          if (imageUrls.length) {
            horizontalScroll.innerHTML = "";
            imageUrls.forEach((imgUrl, index) => {
              const item = document.createElement("div");
              item.className =
                "qv-horizontal-thumbnail-item" +
                (index === currentIndex ? " active" : "");

              const img = document.createElement("img");
              // Use small size for horizontal thumbnails (160x160) for faster loading
              img.src = getOptimizedImageUrl(imgUrl, "large");
              img.alt = `${product.title || "Product"} - image ${index + 1}`;
              img.loading = "lazy";

              item.appendChild(img);
              item.addEventListener("click", () => goToIndex(index));
              horizontalScroll.appendChild(item);
            });
          }
        }

        // Initialize main image and nav buttons
        if (imageUrls.length) {
          setMainImage(currentIndex);
          updateActiveThumb(currentIndex); // Ensure initial thumbnail is properly highlighted and scrolled into view
        }
        if (prevBtn) prevBtn.onclick = imageUrls.length > 1 ? prev : null;
        if (nextBtn) nextBtn.onclick = imageUrls.length > 1 ? next : null;
        if (prevBtn) prevBtn.disabled = imageUrls.length <= 1;
        if (nextBtn) nextBtn.disabled = imageUrls.length <= 1;

        // Initialize horizontal slider buttons
        const horizontalPrevBtn = modal.querySelector(
          ".qv-slider-button--prev"
        );
        const horizontalNextBtn = modal.querySelector(
          ".qv-slider-button--next"
        );
        if (horizontalPrevBtn)
          horizontalPrevBtn.onclick = imageUrls.length > 1 ? prev : null;
        if (horizontalNextBtn)
          horizontalNextBtn.onclick = imageUrls.length > 1 ? next : null;
        if (horizontalPrevBtn)
          horizontalPrevBtn.disabled = imageUrls.length <= 1;
        if (horizontalNextBtn)
          horizontalNextBtn.disabled = imageUrls.length <= 1;

        // Add touch/swipe functionality
        if (imageUrls.length > 1) {
          setupTouchSwipe(mainImageElement, prev, next);
        }
      } else {
        if (titleElement) titleElement.textContent = "Error loading product.";
      }

      // Inject section HTML (variant selectors + form)
      if (sectionRes.status === "fulfilled" && productFormContainer) {
        const html = sectionRes.value;

        // CRITICAL: Ensure cart-drawer is ready BEFORE injecting product-form HTML
        const ensureCartDrawerReady = () => {
          return new Promise((resolve) => {
         

            const checkCartDrawer = () => {
              const cartDrawer = document.querySelector("cart-drawer");
              const isCustomElementDefined = customElements.get("cart-drawer");

      
              if (cartDrawer && isCustomElementDefined) {
                resolve(cartDrawer);
              } else {
                setTimeout(checkCartDrawer, 50);
              }
            };
            checkCartDrawer();
          });
        };

        // Wait for cart-drawer to be ready, THEN inject product-form HTML
        ensureCartDrawerReady().then((cartDrawer) => {
    

          // Load product-form.js if not already loaded BEFORE injecting HTML
          loadProductFormScript().then(() => {
         

            // Inject the HTML - this will trigger the product-form constructor
            productFormContainer.innerHTML = html;

            // Parse and render any rich text metafields
            const metafieldElements = productFormContainer.querySelectorAll(
              ".qv-custom-value, .qv-richtext-value, .qv-collection-value"
            );
            metafieldElements.forEach(parseMetafieldContent);

            // CRITICAL: Immediately after injection, override the cart reference
            // The constructor has just run and set this.cart automatically
            // We need to override it right away before any form submission
            const productForm =
              productFormContainer.querySelector("product-form");

          

            if (productForm && cartDrawer) {
              // Force the cart reference to be the cart-drawer
              Object.defineProperty(productForm, "cart", {
                value: cartDrawer,
                writable: true,
                configurable: true,
              });
           
            } else {
              console.error("Quick view: ✗ Failed to set cart reference!", {
                hasProductForm: !!productForm,
                hasCartDrawer: !!cartDrawer,
              });
            }

            // After injection, wire up variant change handling
            attachVariantHandlers(productFormContainer, productHandle);
            // Evaluate and set button state from returned HTML
            applyButtonStateFromSectionHTML(html, productFormContainer);
            // Quantity selector removed - always add 1 to cart
            // initQuantityControls(productFormContainer);

            // Initialize add to cart functionality
            initAddToCartButton(productFormContainer);
            // Rebind wishlist buttons if helper is available
            if (typeof window.reinitWishlistButtons === "function") {
              window.reinitWishlistButtons();
            }
          }); // Close loadProductFormScript().then()
        }); // Close ensureCartDrawerReady().then()
      }
    })
    .catch((err) => {
      console.error("Quick view load failed:", err);

      // Hide loader and show error immediately
      if (loaderOverlay) loaderOverlay.classList.add("hidden");
      if (titleElement) titleElement.textContent = "Error loading product.";
    });
}

function applyButtonStateFromSectionHTML(sectionHTML, container) {
  try {
    const tmp = document.createElement("div");
    tmp.innerHTML = sectionHTML;
    const variantJson = tmp
      .querySelector("variant-selects [data-selected-variant]")
      ?.textContent?.trim();
    const btn = container.querySelector(".qv-add-to-cart-action");
    if (!btn) return;

    if (!variantJson) {
      btn.setAttribute("disabled", "disabled");
      return;
    }
    const variant = JSON.parse(variantJson);
    if (!variant || variant.available === false) {
      btn.setAttribute("disabled", "disabled");
    } else {
      btn.removeAttribute("disabled");
    }
  } catch (e) {
    console.warn("Failed to evaluate section HTML for variant state", e);
  }
}

function attachVariantHandlers(container, productHandle) {
  const variantSelects = container.querySelector("variant-selects");
  if (!variantSelects) return;

  const getSelectedOptionIds = () =>
    Array.from(
      variantSelects.querySelectorAll(
        "select option[selected], fieldset input:checked"
      )
    )
      .map((el) => el.dataset.optionValueId)
      .filter(Boolean);

  const getProductUrl = (target) =>
    target?.dataset?.productUrl ||
    variantSelects.querySelector("input[data-product-url]")?.dataset
      ?.productUrl ||
    `/products/${productHandle}`;

  variantSelects.addEventListener("change", (event) => {
    const submitBtn = container.querySelector(".qv-add-to-cart-action");

    // Disable button and show loading state on the button
    if (submitBtn) {
      submitBtn.setAttribute("disabled", "disabled");
      submitBtn.classList.add("loading");
    }

    const optionIds = getSelectedOptionIds();
    const productUrl = getProductUrl(event.target);
    const params = new URLSearchParams({ section_id: "quick-view-product" });
    if (optionIds.length) params.append("option_values", optionIds.join(","));

    fetch(`${productUrl}?${params.toString()}`)
      .then((r) => r.text())
      .then((html) => {
        // Parse the new HTML to extract variant data
        const tmp = document.createElement("div");
        tmp.innerHTML = html;

        // Get the new variant ID from the fetched HTML
        const newVariantIdInput = tmp.querySelector('input[name="id"]');
        const newVariantId = newVariantIdInput?.value;

        // Update the existing variant ID input instead of replacing entire HTML
        const existingVariantIdInput =
          container.querySelector('input[name="id"]');
        if (existingVariantIdInput && newVariantId) {
          existingVariantIdInput.value = newVariantId;

          // Update disabled state based on availability
          const variantJson = tmp
            .querySelector("variant-selects [data-selected-variant]")
            ?.textContent?.trim();
          if (variantJson) {
            const variant = JSON.parse(variantJson);
            if (variant && variant.available === false) {
              existingVariantIdInput.setAttribute("disabled", "disabled");
              if (submitBtn) {
                submitBtn.setAttribute("disabled", "disabled");
                submitBtn.classList.remove("loading");
                const btnText = submitBtn.querySelector("span");
                if (btnText) btnText.textContent = "Sold out";
              }
            } else {
              existingVariantIdInput.removeAttribute("disabled");
              if (submitBtn) {
                submitBtn.removeAttribute("disabled");
                submitBtn.classList.remove("loading");
                const btnText = submitBtn.querySelector("span");
                // Get the original button text from Shopify translations or default to "Add to Bag"
                const originalText =
                  btnText.getAttribute("data-original-text") ||
                  document.documentElement.lang === "en"
                    ? "Add to Bag"
                    : "Add to cart";
                if (btnText) btnText.textContent = originalText;
              }
            }
          }
        }

        // Update the selected value display text for the option
        const target = event.target;
        if (target.tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = target.value;
        }

        // Update price for the new variant
        updatePriceFromVariantData(html);

        // Update any dynamic metafield content
        const metafieldElements = tmp.querySelectorAll(
          ".qv-custom-value, .qv-richtext-value, .qv-collection-value"
        );
        metafieldElements.forEach((newMetafield, index) => {
          const existingMetafields = container.querySelectorAll(
            ".qv-custom-value, .qv-richtext-value, .qv-collection-value"
          );
          if (existingMetafields[index]) {
            existingMetafields[index].innerHTML = newMetafield.innerHTML;
            parseMetafieldContent(existingMetafields[index]);
          }
        });
      })
      .catch((e) => {
        console.error("Quick view variant fetch failed", e);
        // Remove loading state on error
        if (submitBtn) {
          submitBtn.classList.remove("loading");
        }
      });
  });
}

function updatePriceFromVariantData(html) {
  try {
    const modal = document.getElementById("quickViewModal");
    const priceElement = modal?.querySelector(".qv-product-price-display");
    if (!priceElement) return;

    // Parse the HTML to extract variant data
    const tmp = document.createElement("div");
    tmp.innerHTML = html;

    const variantJson = tmp
      .querySelector("variant-selects [data-selected-variant]")
      ?.textContent?.trim();

    if (!variantJson) {
      console.warn("No variant data found in section HTML");
      return;
    }

    const variant = JSON.parse(variantJson);
    if (variant && variant.price !== undefined) {
      const cents = typeof variant.price === "number" ? variant.price : 0;

      // Use the same formatting logic as initial price display
      if (window.Shopify?.money_format) {
        priceElement.textContent = formatMoneyForQuickView(
          cents,
          window.Shopify.money_format
        );
      } else if (window.Shopify?.money_with_currency_format) {
        priceElement.textContent = formatMoneyForQuickView(
          cents,
          window.Shopify.money_with_currency_format
        );
      } else {
        // Final fallback for Indian Rupees
        priceElement.textContent = `₹${(cents / 100).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }
    }
  } catch (e) {
    console.warn("Failed to update price from variant data", e);
  }
}

function initQuantityControls(scope) {
  if (!scope) return;
  scope.querySelectorAll(".qv-qty-control").forEach((wrap) => {
    const input = wrap.querySelector(".qv-quantity-input");
    if (!input) return;

    const update = (delta) => {
      const min = Number.isFinite(parseInt(input.min))
        ? parseInt(input.min, 10)
        : 1;
      const max = Number.isFinite(parseInt(input.max))
        ? parseInt(input.max, 10)
        : null;
      let val = Number.isFinite(parseInt(input.value, 10))
        ? parseInt(input.value, 10)
        : min;
      val = val + delta;
      if (val < min) val = min;
      if (max !== null && val > max) val = max;
      input.value = String(val);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };

    wrap.querySelectorAll(".qv-qty-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const action = btn.dataset.action;
        if (action === "increment") update(1);
        else if (action === "decrement") update(-1);
      });
    });
  });
}

function initAddToCartButton(container) {
  const productForm = container.querySelector("product-form");
  const cartDrawer = document.querySelector("cart-drawer");
  const submitButton = container.querySelector(".qv-add-to-cart-action");

  

  // Store original button text
  if (submitButton) {
    const btnText = submitButton.querySelector("span");
    if (btnText && !btnText.getAttribute("data-original-text")) {
      btnText.setAttribute("data-original-text", btnText.textContent.trim());
    }
  }

  // If we have the product-form custom element, it will handle everything automatically
  if (productForm && customElements.get("product-form")) {
 

    // CRITICAL: Force the cart reference to be the cart-drawer after variant change
    if (cartDrawer) {
      // Use a more aggressive approach to ensure cart is set
      Object.defineProperty(productForm, "cart", {
        value: cartDrawer,
        writable: true,
        configurable: true,
      });

      // Also set it directly
      productForm.cart = cartDrawer;

      // Ensure the form knows about cart-drawer
      productForm.setAttribute("data-cart-type", "drawer");

    
    } else {
      console.error(
        "Quick view: ✗ Cart drawer not found in initAddToCartButton!"
      );
    }

    // Ensure button is properly enabled if variant is available
    if (submitButton && !submitButton.hasAttribute("disabled")) {
      submitButton.removeAttribute("disabled");
      submitButton.classList.remove("loading");
    }

    // Listen for cart updates to handle modal closing
    if (
      typeof subscribe === "function" &&
      typeof PUB_SUB_EVENTS !== "undefined"
    ) {

      const handleCartUpdate = (eventData) => {

        // Check if this update might be from our form
        const modal = document.getElementById("quickViewModal");
        if (modal && modal.style.display !== "none") {

          // Dispatch custom event for wishlist integration
          document.dispatchEvent(
            new CustomEvent("cart:added", {
              detail: {
                productHandle: window._currentQuickViewProduct,
                variantId: eventData?.productVariantId,
                cartData: eventData?.cartData,
                source: "quick-view-product-form",
              },
            })
          );


          // Close modal after cart update
          setTimeout(() => {
            closeQuickViewOriginal();
          }, 1000);
        }
      };

      subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    } else {
      console.warn("Quick view: PubSub system not available");
    }

    // Set up listener to close modal after cart drawer fully opens
    const closeModalAfterCartOpen = () => {
      const modal = document.getElementById("quickViewModal");
      if (modal && modal.style.display !== "none") {
       
        setTimeout(() => {
          closeQuickViewOriginal();
        }, 800);
      }
    };

    // Listen for cart drawer to open (it dispatches when renderContents completes)
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.addEventListener("transitionend", closeModalAfterCartOpen, {
        once: true,
      });
    }

    return; // Let the product-form custom element handle everything
  } else if (productForm && !customElements.get("product-form")) {
    console.warn(
      "Quick view: product-form element exists but custom element not yet defined"
    );
    console.warn(
      "Quick view: Setting up manual form submit handler as fallback"
    );

    // Set up manual form submission handler
    const form = productForm.querySelector("form");
    if (form && productForm.cart) {
      form.addEventListener("submit", (evt) => {
        evt.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        if (
          submitButton &&
          submitButton.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        // Disable button and show loading state
        if (submitButton) {
          submitButton.setAttribute("aria-disabled", "true");
          submitButton.classList.add("loading");
          const spinner = submitButton.querySelector(".loading__spinner");
          if (spinner) spinner.classList.remove("hidden");
        }

        const formData = new FormData(form);
        const cartDrawer = productForm.cart;

        if (cartDrawer && cartDrawer.getSectionsToRender) {
          formData.append(
            "sections",
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          if (cartDrawer.setActiveElement) {
            cartDrawer.setActiveElement(document.activeElement);
          }
        }

        // Use fetchConfig if available (from global.js)
        const config =
          typeof fetchConfig === "function"
            ? fetchConfig("javascript")
            : {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              };

        // Set required headers
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"]; // Let browser set this for FormData
        config.body = formData;

        fetch(window.routes?.cart_add_url || "/cart/add.js", config)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((response) => {

            if (response.status) {
              console.error("Quick view: Error adding to cart:", response);
              if (submitButton) {
                submitButton.removeAttribute("aria-disabled");
                submitButton.classList.remove("loading");
                const spinner = submitButton.querySelector(".loading__spinner");
                if (spinner) spinner.classList.add("hidden");
              }
              return;
            }

            // Publish cart update event FIRST
            if (
              typeof publish === "function" &&
              typeof PUB_SUB_EVENTS !== "undefined"
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "quick-view-manual",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }

            // CRITICAL: Close the modal BEFORE rendering cart drawer
            // This prevents z-index and focus trap conflicts
            closeQuickViewOriginal();

            // Small delay to let modal close animation finish
            setTimeout(() => {
              // Then render cart contents and open drawer
              if (cartDrawer) {
            

                if (cartDrawer.renderContents && response.sections) {
               

                  // CRITICAL: Remove is-empty class from cart-drawer element
                  cartDrawer.classList.remove("is-empty");

                  // Also remove from drawer__inner if it exists
                  const drawerInner =
                    cartDrawer.querySelector(".drawer__inner");
                  if (drawerInner) {
                    drawerInner.classList.remove("is-empty");
                  }

                  // Manually render the sections WITHOUT calling open() automatically
                  // We'll call open() ourselves after ensuring DOM is ready
                  cartDrawer.productId = response.id;

                  const sectionsToRender = cartDrawer.getSectionsToRender();
               

                  sectionsToRender.forEach((section) => {
                    const sectionElement = section.selector
                      ? document.querySelector(section.selector)
                      : document.getElementById(section.id);

                 

                    if (!sectionElement) {
                      console.warn(
                        `Quick view: Section element not found for ${section.id}`
                      );
                      return;
                    }

                    if (response.sections[section.id]) {
                      const html = response.sections[section.id];
                      const parsed = new DOMParser().parseFromString(
                        html,
                        "text/html"
                      );
                      const content = parsed.querySelector(
                        section.selector || ".shopify-section"
                      );
                      if (content) {
                        sectionElement.innerHTML = content.innerHTML;
                      
                      }
                    }
                  });

                  // Now wait for DOM to be fully updated, then open the drawer
                  setTimeout(() => {
                    const cartDrawerElement =
                      document.getElementById("CartDrawer");
                 

                    if (
                      !cartDrawerElement ||
                      !cartDrawerElement.querySelector(".drawer__inner")
                    ) {
                      console.error(
                        "Quick view: #CartDrawer not properly rendered, aborting open"
                      );
                      return;
                    }

                    // Manually set up overlay click handler
                    const overlay = cartDrawer.querySelector(
                      "#CartDrawer-Overlay"
                    );
                    if (overlay) {
                      overlay.addEventListener("click", () =>
                        cartDrawer.close()
                      );
                    }

                    // Now open the drawer
                    if (cartDrawer.open) {
                      cartDrawer.open();
                    }
                  }, 200);
                } else {
                  // Fallback: Fetch cart state and open drawer manually
                  console.warn(
                    "Quick view: No sections in response, fetching cart state..."
                  );
                  fetch(
                    window.routes?.cart_url
                      ? `${window.routes.cart_url}.js`
                      : "/cart.js"
                  )
                    .then((r) => r.json())
                    .then((cartData) => {
                      // Manually trigger a cart refresh by publishing update event
                      if (
                        typeof publish === "function" &&
                        typeof PUB_SUB_EVENTS !== "undefined"
                      ) {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: "quick-view-fallback",
                          cartData: cartData,
                        });
                      }
                      // Open the drawer
                      if (cartDrawer.open) {
                        setTimeout(() => cartDrawer.open(), 100);
                      }
                    })
                    .catch((err) => {
                      console.error(
                        "Quick view: Failed to fetch cart state:",
                        err
                      );
                      // Still try to open the drawer
                      if (cartDrawer.open) {
                        cartDrawer.open();
                      }
                    });
                }
              }
            }, 300); // Wait for modal to close before opening cart drawer
          })
          .catch((error) => {
            console.error("Quick view: Fetch error:", error);
            if (submitButton) {
              submitButton.removeAttribute("aria-disabled");
              submitButton.classList.remove("loading");
            }
          });
      });

    } else {
      console.error(
        "Quick view: Cannot set up fallback - form or cart not found"
      );
    }
    // The form will still work because:
    // 1. The cart reference is already set via Object.defineProperty
    // 2. The form's submit handler will use that cart reference
    // 3. Even if the custom element isn't "officially" registered, the properties are set
  } else {
    console.error("Quick view: product-form element not found in container");
  }
}

// Manual cart handling removed - now using product-form custom element

function closeQuickViewOriginal() {
  const modal = document.getElementById("quickViewModal");
  if (modal) {
    document.body.classList.add("qv-modal-transition");

    // Restore body scroll and scroll position when modal closes
    const scrollY = modal.getAttribute("data-scroll-y") || "0";
    document.body.classList.remove("qv-modal-open");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo(0, parseInt(scrollY, 10));
    modal.removeAttribute("data-scroll-y");

    modal.style.display = "none";

    window.setTimeout(() => {
      document.body.classList.remove("qv-modal-transition");
    }, 400);

    // Reset any button states when modal closes
    const addToCartButton = modal.querySelector(".qv-add-to-cart-action");
    if (addToCartButton) {
      addToCartButton.disabled = false;
      addToCartButton.classList.remove("loading");
      addToCartButton.style.background = "";
      addToCartButton.style.color = "";
      addToCartButton.style.transform = "";
      addToCartButton.style.transition = "";

      const spinner = addToCartButton.querySelector(".loading__spinner");
      if (spinner) {
        spinner.classList.add("hidden");
      }

      // Reset button text
      const buttonSpan = addToCartButton.querySelector("span");
      if (
        buttonSpan &&
        (buttonSpan.textContent.includes("Added to Cart!") ||
          buttonSpan.textContent.includes("Error"))
      ) {
        // Try to get the original text from the product form or fallback to default
        const originalButtonText =
          window.theme?.translations?.add_to_cart || "Add to Cart";
        buttonSpan.textContent = originalButtonText;
      } else if (
        !buttonSpan &&
        (addToCartButton.textContent.includes("Added to Cart!") ||
          addToCartButton.textContent.includes("Error"))
      ) {
        const originalButtonText =
          window.theme?.translations?.add_to_cart || "Add to Cart";
        addToCartButton.textContent = originalButtonText;
      }
    }
  } else {
    console.error("Quick view: Modal element not found!");
  }
}

// Make functions globally available
window.closeQuickViewOriginal = closeQuickViewOriginal;
window.openQuickViewOriginal = openQuickViewOriginal;
// Also expose with the names expected by the HTML
window.closeQuickView = closeQuickViewOriginal;
window.openQuickView = openQuickViewOriginal;

// Test function for debugging
window.testCloseModal = function () {
  const modal = document.getElementById("quickViewModal");

  closeQuickViewOriginal();
};

// Test function to simulate cart update
window.testCartUpdate = function () {
  if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "test",
      productVariantId: "123",
      cartData: { test: true },
    });
  } else {
    console.log("PubSub not available");
  }
};

// Close when clicking outside content
(function attachQuickViewListeners() {
  const modal = document.getElementById("quickViewModal");
  if (!modal) {
    // If modal doesn't exist yet, wait for DOM to be ready
    document.addEventListener("DOMContentLoaded", () => {
      attachQuickViewListeners();
    });
    return;
  }

  // Add click listener for close button
  const closeButton = modal.querySelector(".qv-modal-close-button");
  if (closeButton) {
    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      closeQuickViewOriginal();
    });
  }

  // Close when clicking outside content
  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeQuickViewOriginal();
    }
  });

  // Close on Escape key
  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeQuickViewOriginal();
    }
  });
})();

// Auto-open quick view after login if URL contains qv=open&handle=...
document.addEventListener("DOMContentLoaded", () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const shouldOpen = params.get("qv") === "open";
    const handle = params.get("handle");
    if (shouldOpen && handle) {
      // Clean the param so refreshing doesn't re-open repeatedly
      const url = new URL(window.location.href);
      url.searchParams.delete("qv");
      url.searchParams.delete("handle");
      window.history.replaceState({}, "", url.toString());
      openQuickViewOriginal(handle);
    }
  } catch (e) {
    console.warn("Quick view auto-open parse failed", e);
  }
});

// Function to load product-form.js script if not already loaded
function loadProductFormScript() {
  return new Promise((resolve) => {

    // Check if product-form custom element is already defined
    if (customElements.get("product-form")) {
      resolve();
      return;
    }

    // Check if script is already loaded (might be from main-product section)
    const existingScript = document.querySelector(
      'script[src*="product-form.js"]'
    );
    if (existingScript) {
   
      // Script exists but element might not be defined yet, poll for it
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max wait
      const checkInterval = setInterval(() => {
        attempts++;
        if (customElements.get("product-form")) {
          clearInterval(checkInterval);
          resolve();
        } else if (attempts >= maxAttempts) {
          console.warn(
            "Quick view: Timeout waiting for product-form registration"
          );
          console.warn("Quick view: Continuing anyway - form may still work");
          clearInterval(checkInterval);
          resolve(); // Resolve anyway to not block
        }
      }, 100);
      return;
    }

    // Script doesn't exist, don't try to load it dynamically
    // Instead, just resolve and let the form work without custom element
    console.warn("Quick view: product-form.js not found in page");
    console.warn("Quick view: Form will work with basic functionality");
    resolve();
  });
}
